import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { suiteRunSummaryStatusOptions } from '@/shared/constants/statusOptions';
import { getChartTitle } from '@/shared/copy/charts';
import { getDetailLabel } from '@/shared/copy/details';
import type { SuiteRunStatus } from '@flowqa/shared';

export type ExecutionRunsSortKey =
  | 'name'
  | 'status'
  | 'startedAt'
  | 'durationMs'
  | 'resultsFileName'
  | 'resultsFileCreatedAt';

export const executionRunsTableDefinition: TableDefinition<ExecutionRunsSortKey, SuiteRunStatus> =
  createTableDefinition({
    title: 'Execution Runs',
    searchAriaLabel: 'Search execution runs by name',
    columns: [
      { field: 'name', label: getDetailLabel('run'), mandatory: true, defaultVisible: true },
      { field: 'status', label: getChartTitle('status'), defaultVisible: true },
      { field: 'suites', label: getDetailLabel('suites'), defaultVisible: true },
      { field: 'tests', label: getDetailLabel('tests'), defaultVisible: true },
      { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
    ],
    defaultSortKey: 'startedAt',
    defaultSortDirection: 'desc',
    sortOptions: [
      { key: 'startedAt', label: getDetailLabel('timestamp') },
      { key: 'name', label: getDetailLabel('run') },
      { key: 'status', label: getChartTitle('status') },
      { key: 'durationMs', label: getChartTitle('duration') },
      { key: 'resultsFileName', label: 'Results File' },
      { key: 'resultsFileCreatedAt', label: getDetailLabel('uploaded') },
    ],
    sortFieldMap: {
      name: 'name',
      status: 'status',
      startedAt: 'startedAt',
      durationMs: 'durationMs',
      resultsFileName: 'name',
      resultsFileCreatedAt: 'resultsFileCreatedAt',
    },
    statusOptions: suiteRunSummaryStatusOptions,
    statusFilterLabel: getChartTitle('status'),
  });
